<template>
    <div>
        <loadingScreen :isLoading="isLoading"/>
        <div class="page-wrapper" id="wrapper">
            <nav id="sidebar" class="sidebar-wrapper">
                <div class="sidebar-brand">
                    <a class="">
                        <router-link to="/" @click="isCompany = false">
                            <img style="max-width: 250px; margin:auto; width: 176px; margin-top: 5px"
                                 alt="R2 Soft"
                                 src="@/assets/img/logo-pb.png"
                            >
                        </router-link>
                    </a>
                </div>
                <div class="sidebar-content" style="height: 100%;">
                    <menu-component v-if="!companyId"/>
                    <menu-component v-if="companyId" :companyId="companyId"/>
                </div>
            </nav>
            <div class="page-content">
                <header class="header app-layout-header">
                    <div class="app-layout-header__left">
                        <div class="toggle-btns">
                            <a id="toggle-sidebar" style="border-radius: 5px;" href="#"
                               @click.stop.prevent="toggleSidebar()">
                                <i class="icon-list"/>
                            </a>
                            <a id="pin-sidebar" style="border-radius: 5px;" href="#" @click.stop.prevent="pinSidebar()">
                                <i class="icon-list"/>
                            </a>
                        </div>
                    </div>
                    <div class="app-layout-header__center" v-if="!isCompany && companies[0] && toggle">
                        <div class="app-company-switcher">
                            <div class="app-company-switcher-icon">
                                <i class="icon-business_center"></i>
                            </div>
                            <div class="app-company-switcher-field">
                                <span class="app-company-switcher-label">Empresa ativa</span>
                                <Select2 class="app-company-switcher-select" :settings="{'width': '100%'}"
                                         v-model="companySelected" :options="companies"
                                         :valueToSet="companyId" @select="mySelectEvent($event)"/>
                            </div>
                        </div>
                    </div>
                    <div class="app-layout-header__right">
                        <ul class="header-actions right-content">
                            <li class="theme-toggle-action">
                                <button class="theme-toggle-button" :class="{'theme-toggle-button-active': darkTheme === 'ativo'}" type="button" :title="darkTheme === 'ativo' ? 'Tema noturno ativo' : 'Tema diurno ativo'" aria-label="Alternar tema" @click="changeTheme">
                                    <span v-if="darkTheme !== 'ativo'" class="theme-toggle-icon theme-toggle-icon-light">
                                        <i class="icon-sun"></i>
                                    </span>
                                    <span v-else class="theme-toggle-icon theme-toggle-icon-dark">
                                        <i class="icon-cloud1"></i>
                                    </span>
                                </button>
                            </li>
                            <profile :isSecurity="havePassword" :user="profile" @logout="logout"
                                     @update="setProfileModal()"/>
                        </ul>
                    </div>
                </header>
                <div class="main-container">
                    <router-view/>
                    <modal-company-component v-if="showModal" load-permissions
                                              @alterPermissions="mySelectEvent"/>
                    <input type="hidden" name="triger" id="profileTrigger" data-target="#modalProfile"
                           data-toggle="modal">
                    <div class="modal fade" id="modalProfile" data-backdrop="static" role="dialog"
                         aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog modal-xl" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="footerCenterBtnsModalLabel">
                                        <slot name="title">{{ t('APP.PROFILE') }}</slot>
                                    </h5>
                                    <button type="button" class="closeX" id="closeProfile" data-dismiss="modal"
                                            aria-label="Close"
                                            @click="closeFirstModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <profile-modal v-if="openProfile" :profileIndex="profile"
                                               @update="selectCompany()"></profile-modal>
                            </div>
                        </div>
                    </div>
                    <input type="hidden" name="imageCropper" id="imageCropper" data-target="#modalCropper"
                           data-toggle="modal">
                    <cropper-img @cropperUpdate="isCropping = false"/>
                    <input type="hidden" name="triger" id="profileTrigger" data-target="#modalPassword"
                           data-toggle="modal">
                    <div class="modal fade" id="modalPassword" data-backdrop="static" role="dialog"
                         aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div class="modal-dialog lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="footerCenterBtnsModalLabel">
                                        <slot name="title">{{ t('APP.PROFILE') }}</slot>
                                    </h5>
                                    <button type="button" class="closeX" id="closeProfile" data-dismiss="modal"
                                            aria-label="Close"
                                            @click="closeFirstModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <password-modal v-if="openProfile" :profileIndex="profile"
                                                @update="selectCompany"></password-modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {useI18n} from 'vue-i18n';
import User from '@/services/user';
import {defineComponent} from 'vue';
import jwt_decode from 'jwt-decode';
import {mapActions, mapState} from 'vuex';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import 'vue-advanced-cropper/dist/style.css';
import {event} from 'vue-gtag';
import Profile from '@/components/layouts/profile';
import CropperImg from '@/components/layouts/cropper';
import MenuComponent from '@/components/layouts/menuComponent';
import ModalCompanyComponent from '@/components/layouts/modalCompanyComponent';
import LoadingScreen from '@/components/layouts/loadScreenComponent.vue';
import profileModal from '@/components/layouts/profileModalComponent.vue';
import passwordModal from '@/components/layouts/changePasswordComponent.vue';

export default defineComponent({
    name: 'AppLayout',
    components: {
        Profile,
        Select2,
        CropperImg,
        profileModal,
        passwordModal,
        LoadingScreen,
        MenuComponent,
        ModalCompanyComponent,
    },
    setup() {
        const login = () => {
            event('login', {method: 'Google'});
        };
        const {t} = useI18n();
        const toast = useToast();
        return {t, toast, login};
    },
    data() {
        return {
            profile: null,
            companiesAux: [],
            toggle: true,
            isCropping: false,
            havePassword: true,
            openProfile: false,
            openPassword: false,
            companyModal: null,
            companySelected: '',
            companyNotLoad: false,
            showSelect2: this.$route.name != 'Company',
            companyId: localStorage.getItem('companyId'),
        };
    },
    computed: {
        ...mapState({
            image: 'image',
            darkTheme: 'darkTheme',
            minutesForExpiration: 'minutesForExpiration',
            pinned: 'pinned',
            toggled: 'toggled',
            isLoading: 'isLoading',
            showModal: 'showModal',
            companies: 'companies',
            isCompany: 'isCompany',
            oneToExpire: 'oneToExpire',
            fiveToExpire: 'fiveToExpire',
            closeAlertRefresh: 'closeAlertRefresh',
            showReahtorizationAlert: 'showReahtorizationAlert',
        }),
    },
    watch: {
        minutesForExpiration() {
            let currentTime = new Date().getTime() / 1000.0;
            if (currentTime > this.$store.state.fiveToExpire){
                this.showAlert();
            }
        },
        showReahtorizationAlert: function () {
            if (this.showReahtorizationAlert == 5 || this.showReahtorizationAlert == 1) {
                this.showAlert();
            } else if (!this.showReahtorizationAlert) {
                this.$swal.close();
            }
        },
        toggled: function () {
            this.toggle = !(this.toggled);
        },
    },
    mounted() {
        this.startTime();
        this.profile = JSON.parse(localStorage.getItem('user'));
        //  this.indexUser(jwt_decode(localStorage.getItem('access_token')).idUsuario);
        this.startCompany();
        this.createGoogletagmanager();
        this.getHasConfigClickSign();
        this.checkPreLogin();
        this.$store.dispatch('ActionRefreshTokenTime');
    },
    created() {
        this.$store.commit('startCompaniesToken');
    },
    methods: {
        ...mapActions({
            getHasConfigClickSign: 'getHasConfigClickSign'
        }),
        changeTheme() {
            if (this.darkTheme === 'ativo') {
                localStorage.removeItem('darkTheme');
                this.$store.state.darkTheme = false;
                return;
            }

            localStorage.setItem('darkTheme', 'ativo');
            this.$store.state.darkTheme = 'ativo';
        },
        createGoogletagmanager() {
            setTimeout(() => {
                const token = jwt_decode(localStorage.getItem('access_token'));
                if (token && process.env.NODE_ENV === 'production') {
                    const body = document.getElementsByTagName('body')[0];
                    const script = document.createElement('script');
                    script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-EX1N4ML033');
                    script.async = true;
                    const userName = token.name;
                    const companyId = localStorage.getItem('companyId');
                    let companyName = '';
                    if (this.companies?.length && companyId) {
                        this.companies.forEach(item => {
                            if (item.id === companyId) {
                                companyName = item.text;
                            }
                        });
                    }
                    body.appendChild(script);
                    window.dataLayer = window.dataLayer || [];
                    this.gtag('js', new Date());
                    if (companyName.length > 15) {
                        companyName = companyName.substring(0, 15);
                    }
                    this.gtag('config', 'G-EX1N4ML033', {
                        'page_title': companyName + ' - ' + userName,
                    });
                    this.gtag('event', 'screen_view', {
                        'app_name': 'R2 Disponibilidade',
                        'screen_name': userName,
                    });
                }
            }, 4000);
        },
        gtag() {
            window.dataLayer.push(arguments);
        },
        logout() {
            this.$store.dispatch('ActionSingOut');
            this.$router.push({
                name: 'Login',
            });
        },
        checkPreLogin()
        {
            let token = jwt_decode(localStorage.getItem('access_token'));
            if (token?.pre_login){
                this.selectCompany();
            }
        },
        async mySelectEvent(event) {
            this.$store.commit('changeLoading', true);
            this.companyId = event.id;
            localStorage.removeItem('companyId');
            localStorage.setItem('companyId', event.id);
            localStorage.removeItem('allotmentId');
            localStorage.removeItem('userAllotmentId');
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.removeItem('access_token_custom');
            sessionStorage.removeItem('refresh_token_custom');
            await User.alterCompanyPermissionsUser( {
                company: event.company_id,
                connection: event.id,
            }).then(async (resp) => {
                resp.data.companyId = event.id;
                await this.$store.dispatch('ActionDoLoginSecurity', resp.data);
                this.$router.go();
            }).catch((err) => {
                this.errorMsg(err);
                this.$store.commit('changeLoading', false);
            })
        },
        startCompany() {
            document.body.classList.remove('authentication');
            this.companySelected = localStorage.getItem('companyId');
        },
        startTime() {
            var date = new Date();
            var currentTime = new Date(date).getTime() / 1000.0;
            if (currentTime > this.expirationTime) {
                this.$swal.close();
            }
        },
        selectCompany() {
            const companyId = localStorage.getItem('companyId');
            if (this.companies.length == 1) {
                this.$store.commit('showModalSelectCompany', false);
                this.companyId = this.companies[0].id;
                this.companySelected = this.companies[0].id;
                localStorage.setItem('companyId', this.companies[0].id);
                this.mySelectEvent(this.companies[0]);
            } else if (!companyId && this.companies[0]) {
                this.$store.commit('showModalSelectCompany', true);
            }
        },
        showAlert() {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.SOME_TIME_TO_END_SESSION', {time: this.minutesForExpiration}),
                showCloseButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonText: `Renovar`,
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    await this.$store.dispatch('ActionRefreshToken');
                    this.$store.commit('changeLoading', false);
                    return;
                }
                let currentTime = new Date().getTime() / 1000.0;
                if (currentTime > this.$store.state.expirationTime) {
                    this.$store.dispatch('ActionSingOut');
                    this.$router.push({name: 'Login'});
                }
            }).catch(() => {
                this.$store.dispatch('ActionSingOut');
                this.$router.push({name: 'Login'});
            });
        },
        pinSidebar() {
            if (this.pinned) {
                document.getElementById('wrapper').classList.remove('pinned');
            } else {
                document.getElementById('wrapper').classList.add('pinned');
                document.getElementById('configSubmenu').classList.remove('show');
            }
            this.$store.commit('pinSidebar');
        },
        toggleSidebar() {
            if (this.toggled) {
                document.getElementById('wrapper').classList.remove('toggled');
            } else {
                document.getElementById('wrapper').classList.add('toggled');
                document.getElementById('configSubmenu').classList.remove('show');
            }
            this.$store.commit('toggleSidebar');
        },
        async setProfileModal() {
            this.$store.commit('changeLoading', true);
            this.$store.commit('setImageCropped', null);
            let userId = jwt_decode(localStorage.getItem('access_token')).idUsuario;
            await User.show(userId).then(resp => {
                this.profile = resp.data;
                this.openProfile = true;
            }).catch(error => this.errorMsg(error)).finally(() => this.$store.commit('changeLoading', false));
        },
        async indexUser(id) {
            await User.show(id).then(resp => {
                if (resp.data.havePassword === false) {
                    this.havePassword = false;
                }
                this.profile = resp.data;
                if (!resp.data.phones[0]) {
                    if (localStorage.getItem('firstProfileClosed') == null || localStorage.getItem('firstProfileClosed') == 'true') {
                        localStorage.setItem('firstProfileClosed', true);
                        document.getElementById('profileTrigger').click();
                        this.openProfile = true;
                    }
                } else {
                    this.selectCompany();
                }
            }).catch(error => this.errorMsg(error));
        },
        closeFirstModal() {
            if (localStorage.getItem('firstProfileClosed') == 'true') {
                localStorage.setItem('firstProfileClosed', false);
            }
        },
    },
});

</script>
<style lang="less">
.size {
    width: 200px !important;
}

.app-layout-header {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    column-gap: 1rem;
}

.app-layout-header__left,
.app-layout-header__right {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
}

.app-layout-header__left {
    grid-column: 1;
}

.app-layout-header__center {
    grid-column: 2;
    justify-self: center;
    width: 42vw;
    max-width: 420px;
}

.app-layout-header__right {
    grid-column: 3;
    justify-self: end;
}

.theme-toggle-action {
    display: flex;
    align-items: center;
    justify-content: center;
}

.theme-toggle-button {
    width: 40px;
    height: 38px;
    padding: 0;
    border: 1px solid rgba(14, 94, 78, 0.2);
    border-radius: 10px;
    background: linear-gradient(145deg, #ffffff, #eef7f4);
    box-shadow: 0 8px 18px rgba(31, 45, 61, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.95);
    color: #0e5e4e;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
}

.theme-toggle-button::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(14, 94, 78, 0.14), transparent 55%);
    opacity: 0;
    transition: opacity 0.18s ease;
}

.theme-toggle-button:hover,
.theme-toggle-button:focus {
    border-color: rgba(14, 94, 78, 0.36);
    background: linear-gradient(145deg, #ffffff, #e6f4ef);
    box-shadow: 0 12px 26px rgba(31, 45, 61, 0.16), inset 0 1px 0 rgba(255, 255, 255, 1);
    color: #0a4b3f;
    outline: none;
    transform: translateY(-1px);
}

.theme-toggle-button:hover::before,
.theme-toggle-button:focus::before {
    opacity: 1;
}

.theme-toggle-button:active {
    box-shadow: 0 5px 14px rgba(31, 45, 61, 0.12), inset 0 2px 5px rgba(14, 94, 78, 0.12);
    transform: translateY(0);
}

.theme-toggle-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: relative;
    z-index: 1;
}

.theme-toggle-icon-light {
    color: #f59e0b;
}

.theme-toggle-icon-dark {
    color: #0f766e;
}

.app-company-switcher {
    display: flex;
    align-items: center;
    gap: 0.42rem;
    width: 100%;
    height: 42px;
    padding: 0.32rem 0.44rem;
    border: 1px solid rgba(14, 94, 78, 0.16);
    border-radius: 9px;
    background: #ffffff;
    box-shadow: none;
    transition: border-color .16s ease, background-color .16s ease;
}

.app-company-switcher:hover,
.app-company-switcher:focus-within {
    border-color: rgba(14, 94, 78, 0.34);
    background: #ffffff;
}

.app-company-switcher-icon {
    width: 25px;
    height: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 25px;
    border-radius: 7px;
    background: #f6f8fa;
    color: #0e5e4e;
    font-size: 0.78rem;
    box-shadow: none;
}

.app-company-switcher-field {
    flex: 1;
    min-width: 0;
}

.app-company-switcher-label {
    display: block;
    margin-bottom: 0.08rem;
    color: #727272;
    font-size: 0.60rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0.02em;
}

.app-company-switcher-select.select2-container,
.app-company-switcher .select2-container {
    width: 100% !important;
}

.app-company-switcher .select2-container--default .select2-selection--single {
    height: 20px !important;
    min-height: 20px !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
}

.app-company-switcher .select2-container--default .select2-selection--single .select2-selection__rendered {
    padding-left: 0 !important;
    padding-right: 1.3rem !important;
    color: #1f2937 !important;
    font-size: 0.76rem !important;
    font-weight: 800 !important;
    line-height: 20px !important;
}

.app-company-switcher .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 0 !important;
    right: 0 !important;
    height: 20px !important;
}

.app-company-switcher .select2-container--default .select2-selection--single .select2-selection__arrow b {
    border-top-color: #0e5e4e !important;
}

.app-company-switcher .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
    border-bottom-color: #0e5e4e !important;
}

.app-company-switcher .select2-container--default .select2-selection--single:focus,
.app-company-switcher .select2-container--default.select2-container--focus .select2-selection--single {
    outline: none !important;
    box-shadow: none !important;
}

@media (max-width: 767.98px) {
    .app-layout-header {
        column-gap: 0.55rem;
        padding: 0 0.75rem;
    }

    .app-layout-header__center {
        width: auto;
        min-width: 0;
        flex: 1 1 auto;
        justify-self: stretch;
    }

    .app-company-switcher {
        gap: 0.35rem;
        padding: 0.18rem 0.35rem;
    }

    .app-company-switcher-icon,
    .app-company-switcher-label {
        display: none;
    }

    .app-company-switcher .select2-container--default .select2-selection--single .select2-selection__rendered {
        font-size: 0.72rem !important;
    }
}

.size-modal {
    width: 100% !important;
}

.btn-background {
    width: 100%;
    font-size: large !important;
    font-weight: 600 !important;
    background-color: #adadad !important;
}

.modal-dialog {
    overflow-y: initial !important
}

.modal-row2 {
    max-height: 40vh;
    overflow-y: auto;
}

.modal-row {
    max-height: 40vh;
    overflow-y: auto;
}

.modal-row2::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
    background: transparent !important;
}

.modal-row2::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 10px;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-header-color {
    color: white;
    background-color: #0e5e4e !important;
}

.right-content {
    justify-content: flex-end;
}

.swal2-container {
    z-index: 100000000000;
}

.user-avatar {
    max-width: 80px !important;
    max-height: 80px !important;
    border-radius: 50% !important;
    margin-bottom: 1.2rem !important;
}

.avatar-size {
    width: 80px !important;
    height: 80px !important;
}

.cropper-size {
    max-width: 350px !important;
    max-height: 275px !important;
}

.avatar .status {
    top: 62px;
    right: 2px;
    width: 25px;
    height: 25px;
    font-size: 18px;
    position: absolute;
    border-radius: 15px;
    border: 4px solid #f0f0f0;
}

.camera {
    right: 1;
    bottom: 0;
    outline: 0;
    cursor: pointer;
    font-size: 18px;
    position: absolute;
    border-radius: 15px;
    background-color: #f0f0f0;
}

.align-items {
    align-items: center;
}

.preview {
    border: dashed 1px rgba(255, 255, 255, 0.25);
}

.cropper {
    height: 100%;
    background: #DDD;
}

.hearder-custom {
    color: #333333 !important;
    background: #ffffff !important;
}

.close-custom {
    color: #000 !important;
}

.border-bottom {
    border-bottom: 1px solid #e6ebf1;
}

.border-top {
    background-color: #f2f4f9;
    border-top: 1px solid #e6ebf1;
}

.lg {
    max-width: 800px !important;
}

.card-hover-scale:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}
</style>
